import React, { useState } from 'react'

export const RefreshSideListContext = React.createContext()

export const withRefreshSideList = Component => props => {
	const [refreshSideList, setRefreshSideList] = useState()
	const value = {
		refreshSideList,
		setRefreshSideList: setRefreshSideList
	}
	return(
		<RefreshSideListContext.Provider value={value}>
			<Component {...props}/>
		</RefreshSideListContext.Provider>
	)
}
